// This component is deprecated but still required for legacy features
import BaseTable from '@/components/table/BaseTable';

export const LegacyTaskTable = (props: any) => {
  return <BaseTable {...props} />; // NOSONAR
};
